import { useCompatRouter as useRouter } from "@/lib/compat-router/context";
import { getPostAuthRedirect } from "@/utils/helpers/authReturn";

export function useAuthRedirect(fallback = "/user/dashboard") {
  const router = useRouter();
  const target = getPostAuthRedirect(router.query.redirect, fallback);
  const navigateAfterAuth = () => router.push(target);
  return { target, navigateAfterAuth };
}
